import dayjs   from "dayjs";
import fromNow from "dayjs/plugin/relativeTime";
import utc     from "dayjs/plugin/utc";
import dynamic from "next/dynamic";
import Link    from "next/link";

import { getBaseURL, shortenNumber } from "_common/utils";
import Icon                          from "_components/atoms/icon";
import Image                         from "_components/atoms/image";
import Typography                    from "_components/atoms/typography";
import Tags                          from "_components/organisms/videoCardList/videoCard/tags";
import useStyles                     from "_styles/molecules/searchContentBox";

const ReportFollowModal = dynamic ( () => import ( "_components/molecules/reportFollowModal" ), { ssr: false } );

const component = ( { session, lastIndex, currentIndex, handleGAEvent, direction, disableFollowModal, isHorizontal, customClass } ) => {
	const {
		thumbnail,
		streamTitle,
		streamerName,
		views,
		isCeleb,
		videoId,
		isLive,
		profileId,
		profilePic,
		isFollowing,
		createdAt = null,
		feedType,
		game
	} = session;

	dayjs.extend ( utc );
	dayjs.extend ( fromNow );
	const createdTS = createdAt ? dayjs ( dayjs.utc ( createdAt ) ).fromNow () : null;

	const { classes }    = useStyles ( { lastIndex, currentIndex, direction, customClass } );
	const videoHref      = `/video/${ videoId }`;
	const liveStreamHref = `/stream/${ videoId }`;
	let totalViews       = shortenNumber ( views );

	const getNextUrl = () => {

		if ( feedType === "broadcast" ) return liveStreamHref;

		return videoHref;
	};

	const renderLowerComponent = () => {

		if ( isHorizontal ) {
			return (
				<div style = { { display: "flex" } }>
					<Image
						className   = { classes.image }
						placeholder = "/images/circle-placeholder.webp"
						src         = { profilePic }
					/>

					<div style = { { display: "flex", flexDirection: "column" } }>
						<Link href = { ( feedType === "broadcast" ) ? liveStreamHref : videoHref }>
							<Typography
								className = { classes.streamTitle }
								onClick   = { () => handleGAEvent ( { isLive, game, type: "media" } ) }
								title     = { streamTitle }
							/>
						</Link>

						<Link href = { `/profile/${ profileId }` }>
							<div
								className = { classes.nameAndImageContainer }
								onClick   = { () => handleGAEvent ( { isLive, game, type: "profile" } ) }
							>

								<Typography
									className = { classes.name }
									color     = { "secondary" }
									title     = { streamerName }
								/>

								{isCeleb ? (
									<Icon sameInBothTheme
										className = { classes.verifiedSvg }
										name      = "verifiedProfile"
									/>
								) : null}
							</div>

						</Link>

						<div className = { classes.streamInfo }>
							<span className = { classes.timeStampOverflow }>
								{createdTS}
							</span>

							{createdTS ? <div className = { classes.ellipse }></div> : null}

							<span className = { classes.timeStampOverflow }>
								{totalViews}

								{" "}
								Views
							</span>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<>
					<Link href = { ( feedType === "broadcast" ) ? liveStreamHref : videoHref }>
						<Typography
							className = { classes.streamTitle }
							onClick   = { () => handleGAEvent ( { isLive, game, type: "media" } ) }
							title     = { streamTitle }
						/>
					</Link>

					<Link href = { `/profile/${ profileId }` }>
						<div
							className = { classes.nameAndImageContainer }
							onClick   = { () => handleGAEvent ( { isLive, game, type: "profile" } ) }
						>
							<Image
								className   = { classes.image }
								placeholder = "/images/circle-placeholder.webp"
								src         = { profilePic }

							/>

							<Typography
								className = { classes.name }
								color     = { "secondary" }
								title     = { streamerName }
							/>

							{isCeleb ? (
								<Icon sameInBothTheme
									className = { classes.verifiedSvg }
									name      = "verifiedProfile"
								/>
							) : null}
						</div>

					</Link>

					<div className = { classes.streamInfo }>
						<span className = { classes.timeStampOverflow }>
							{createdTS}
						</span>

						{createdTS ? <div className = { classes.ellipse }></div> : null}

						{" "}

						{totalViews}

						{" "}
						Views
					</div>
				</>
			);
		}

	};

	return (
		<div className = { classes.boxContainer }>
			<div
				className = { classes.imgContainer }
				onClick   = { () => handleGAEvent ( { isLive, game, type: "media" } ) }
			>

				<Tags data = { session } />

				<Link href = { ( feedType === "broadcast" ) ? liveStreamHref : videoHref }
					passHref  = { true }
				>
					<Image
						className   = { classes.thumbnail }
						placeholder = "/images/rectangle-placeholder.webp"
						src         = { thumbnail }
					/>
				</Link>
			</div>

			<div className = { classes.contentContainer }>
				<div className = { classes.contentWrapper }>

					{renderLowerComponent ()}

				</div>

				{!disableFollowModal && (
					<div className = { classes.flex }>

						<ReportFollowModal
							feedId            = { videoId }
							feedType          = { feedType }
							from              = { "results-page" }
							getSrc            = { () => getBaseURL () + getNextUrl () }
							isFollowing       = { isFollowing }
							onClickShareModal = { () => {
								return;
							} }
							userId            = { profileId }
							userName          = { streamerName }
							verticalFeedType  = "report-only"
						/>
					</div>
				)}

			</div>

		</div>
	);
};

export default component;
